module.exports = __webpack_public_path__ + "static/media/iyzico-setup-step3.fadb463a.png";